import React, { useState, useContext, useRef } from 'react';
import { Alert } from 'react-bootstrap'
import { SettingsContext } from './AccountSettingsButton'
import CreateNewUser1 from './CreateNewUser1'
import CustomAvatar from "utils/CustomAvatar";


export default function ClientUsers1(props) {

  const context = useContext(SettingsContext);

  let xIcon = require("images/lite/icons/x-close.svg");
  xIcon = (
    <img className="remove-access-icon" alt="remove" src={`/datapulse${xIcon}`} />
  );

  const [users, setUsers] = useState(props.userType === "client" ? context.clientUsers : context.teamUsers)
  const [userExistsWarning, setUserExistsWarning] = useState("")



  return (
    <div className="lite-client-access-container">
       {userExistsWarning !== "" && (
        <div className="user-exists-warning" onClick={()=>{setUserExistsWarning("")}}>
    <Alert  className="" variant="warning">{userExistsWarning}</Alert>
    </div>
  )}

      <div className={props.userType == "client" ? "client-user-list": "team-user-list"}>
        {users.map((user, index) => (
          <React.Fragment key={index}>
          {props.userType === "client" ?

            <div className="user-row">
            <div className="client-box">
            <input type="text" value={user.email} disabled />
            </div>
              <div className="close-x">
                {xIcon}
              </div>
              <div>
              <p className={user.active ? "active" : "invited"}>
              {user.active ? "Active" : "Invited"}
              </p>
              </div>
              </div>
              :
              <div className="employee-box-y">
                {/* <CustomAvatar src={user.avatar} className="avatar"/> */}
                {user.name ? user.name : user.first_name + " " + user.last_name} 
              </div>
            }
            </React.Fragment>
        ))}
      </div>
      
      <CreateNewUser1 userExistsWarning={userExistsWarning} setUserExistsWarning={setUserExistsWarning} clients={context.clients} createUserPath={context.createUserPath} pathMethod={context.pathMethod} userType={props.userType} />
    </div>
  );
}
